
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/collections/[code]",
      function () {
        return require("private-next-pages/catalog/collections/[code].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/collections/[code]"])
      });
    }
  